export const dutch = {
  lang: 'nl',
  data: {
    ADMIN: {
      ADMINISTRATIONS: 'Administraties',
      ALL_ADMINISTRATIONS: 'Alle administraties',
      SAVE: 'Opslaan',
      OWNER: 'Eigenaar',
      OWNER_ID: 'Eigenaar ID',
      OWNER_NAME: 'Eigenaar',
      BLOCK: 'Blokkeer administratie',
      DELETE: 'Verwijder administratie',
      LEDGER: 'Bekijk administratie',
      LOGIN: 'Inloggen als deze administratie',
      STREET: 'Straat',
      NAME: 'Bedrijfsnaam',
      NUMBER: 'Nummer',
      NUMBER_ADD: 'Nummer toev.',
      ZIPCODE: 'Postcode',
      CITY: 'Plaats',
      COUNTRY: 'Land',
      EMAIL: 'E-mail',
      PHONE_NUMBER: 'Telefoonnummer',
      MOBILE_NUMBER: 'Mobiel nummer',
      COC_NUMBER: 'KVK',
      VAT_NUMBER: 'BTW-nummer',
      SBI: 'Standaard bedrijfsindeling (SBI)',
      WEBSITE: 'Website',
      RESEND_SUCCESS: 'Administratie bijgewerkt',
      BACK: 'Terug',
      USER: 'Gebruiker',
      USERS: 'Gebruikers',
      DETAILS: 'Details',
      USERNAME: 'Naam',
      USEREMAIL: 'Email',
      USERROLE: 'Rol',
      ROLE_ADMIN: 'Admin',
      ROLE_OWNER: 'Eigenaar',
      ROLE_ACCOUNTANT: 'Boekhouder',
      ROLE_READ_ONLY: 'Bekijker',
      ROLE_USER: 'Gebruiker',
      RESEND_INVITE: 'Verstuur uitnodiging',
      STOPPED_AT: 'Gestopt op',
      CREATED_AT: 'Aangemaakt op',
      STOPPED: 'Gestopt',
      LEGAL_FORM: 'Rechtsvorm',
      START_DATE: 'Startdatum',
      IBAN: 'IBAN',
      HAS_VAT: 'BTW plichtig',
      true: 'Ja',
      false: 'Nee',
      DOCUMENTS: 'Documenten',
      DOWNLOAD_DOCUMENTS: 'Documenten downloaden',
      DOWNLOAD_SELECTION: 'Download deze documenten',
      DOWNLOAD_ALL: 'Download alle documenten',
      STATUS: 'Status',
      INVOICETYPE: 'Type',
      PURCHASE: 'Inkoop',
      SALES: 'Verkoop',
      PROCESSED: 'Verwerkt',
      REJECTED: 'Afgekeurd',
      IN_PROGRESS: 'In behandeling',
      DATE: 'Upload datum',
      BANKACCOUNTS: 'Bankrekeningen',
      ACCOUNT_NAME: 'Rekeninghouder',
      BANK_ACCOUNT_TYPE: 'Type',
      BALANCE: 'Saldo',
      BALANCE_DATE: 'Saldo datum',
      BANK_ACCOUNT_STATE: 'Status',
      TYPE_CHECKING: 'Betaalrekening',
      TYPE_SAVINGS: 'Spaarrekening',
      BANK: 'Bank',
      SOLE_PROP: 'Eenmanszaak',
      BV: 'BV',
      TRIAL: 'Proef',
      SUBSCRIPTION: 'Betaald',
      TRIAL_END: 'Proef tot',
      ACCOUNT_TYPE: 'Plan',
      STATE_VERIFIED: 'Geverifieerd',
      STATE_MANUALLY_ADDED: 'Handmatig',
      NEW_BANK_ACCOUNT: 'Nieuwe bankrekening',
      EDIT_BANK_ACCOUNT: 'Bewerk bankrekening',
      BILLING: {
        NAME: 'Abonnement',
        TYPE: 'Type',
        PLAN: 'Plan',
        INTERVAL: 'Interval',
        SERVICE: 'Service',
        STRIPE: 'Stripe',
        APPLE: 'Apple',
        MANUAL: 'Handmatig',
        IN_TRIAL: 'In proefperiode',
        IN_SUBSCRIPTION: 'In abonnement',
        SUBSCRIPTION_START_DATE: 'Abonnement gestart op: ',
        TRIAL_END_DATE: 'Einde proefperiode',
        CONSENT: 'Akkoord automatische incasso',
        CONSENT_STATUS: 'Status incasso',
        SUBSCRIPTION_EXEMPT: 'uitgesloten van abonnement',
        TRIAL_DURATION: 'Duur proefperiode',
        MONTH: 'maand',
        MONTHS: 'maanden',
        STRIPE_NAME: 'Naam in Stripe',
        STRIPE_EMAIL: 'E-mail in Stripe',
        STRIPE_VAT: 'BTW-ID in Stripe',
        STRIPE_STATUS: 'Stripe status',
        STRIPE_TRIAL_ENDS_AT: 'Einde Stripe proefperiode',
        STRIPE_BANK_ACCOUNT: 'Rekeningnummer incasso',
      },
      DOWNLOAD: {
        TITLE: 'Download documenten voor <strong>{{administration}}</strong>',
        START_DATE: 'Startdatum',
        END_DATE: 'Einddatum',
        DOWNLOAD_BUTTON_SELECTION: 'Download selectie',
        DOWNLOAD_BUTTON_ALL: 'Download alle',
        TIMING_REMARK:
          'Let op: afhankelijk van de periode die je selecteert, kan het enkele minuten duren om alle documenten te downloaden.',
        TIMING_REMARK_ALL: 'Let op: het kan enkele minuten duren om alle documenten te downloaden.',
        NO_FILES: 'Er zijn geen bestanden gevonden voor de geselecteerde periode.',
        ERROR: 'Er is iets fout gegaan.',
      },
    },
  },
}



// WEBPACK FOOTER //
// ./src/app/main/content/administrations/i18n/nl.ts